import { Component, Input, OnInit } from "@angular/core";
import { UiAvatarSize } from "../../avatar.models";
import { IAssignee, IDeletedAssignee } from "@gtmhub/assignees";
import { UiTooltipPosition } from "@webapp/ui/tooltip/tooltip.models";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { IFullNameSettings } from "@webapp/ui/gh-full-name/gh-full-name.models";

@Component({
  selector: "ui-assignee",
  exportAs: "uiAssignee",
  templateUrl: "assignee.component.html",
  styleUrls: ["./assignee.component.less"],
  host: {
    class: "ui-assignee-wrapper",
    "[class.ui-assignee-x-small]": `size === 'xs'`,
    "[class.ui-assignee-small]": `size === 'sm'`,
    "[class.ui-assignee-medium]": `size === 'md'`,
    "[class.ui-assignee-large]": `size === 'lg'`,
    "[class.ui-assignee-x-large]": `size === 'xl'`,
  },
})
export class UiAssigneeComponent implements OnInit {
  @Input("uiAssignee")
  public assignee: IAssignee | IDeletedAssignee;

  @Input("uiSize")
  public size: UiAvatarSize = "md";

  @Input("uiNameEllipsis")
  @InputBoolean()
  public nameEllipsis?: boolean;

  @Input("uiNameMultiline")
  @InputBoolean()
  public nameMultiline?: boolean;

  @Input("uiNameCenter")
  @InputBoolean()
  public nameCenter?: boolean = true;

  @Input("uiNameMaxLength")
  public nameMaxLength?: number = Infinity;

  @Input("uiShowTooltip")
  @InputBoolean()
  public showTooltip?: boolean;

  @Input("uiTooltipPlacement")
  public tooltipPlacement?: UiTooltipPosition;

  public fullNameSettings?: IFullNameSettings;

  public ngOnInit(): void {
    this.fullNameSettings = {
      nameEllipsis: this.nameEllipsis,
      center: this.nameCenter,
      multiline: this.nameMultiline,
      maxLength: this.nameMaxLength,
    };
  }
}
